<template>
	<div>
		<b-col>
			<b-card no-body>
				<b-card-header>
					<b-row
						align-h="between"
						class="w-100"
					>
						<b-col cols="auto">DETALLE DE LA VENTA: {{ saleData.code }}</b-col>
						<b-col
							cols="auto"
						>{{ saleData.createdAt ? formatDate(saleData.createdAt, 'DD/MM/YYYY HH:mm:ss') : '---' }}</b-col>
					</b-row>
				</b-card-header>
				<b-card-body>
					<b-row>
						<!-- User Data: Code -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="CÓDIGO DE LA VENTA"
								label-for="code"
							>
								<b-form-input
									id="code"
									:value="saleData.code"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Names -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="NOMBRE(S)"
								label-for="names"
							>
								<b-form-input
									id="names"
									:value="saleData.user_data.names"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Surnames -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="APELLIDO(S)"
								label-for="surnames"
							>
								<b-form-input
									id="surnames"
									:value="saleData.user_data.surnames"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Address -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="DIRECCIÓN"
								label-for="address"
							>
								<b-form-input
									id="address"
									:value="saleData.user_data.address"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Housing Type -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="TIPO DE DIRECCIÓN"
								label-for="housing_type"
							>
								<b-form-input
									id="housing_type"
									:value="saleData.user_data.housing_type"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Department -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="DEPARTAMENTO"
								label-for="department"
							>
								<b-form-input
									id="department"
									:value="saleData.user_data.department"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Province -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="PROVINCIA"
								label-for="province"
							>
								<b-form-input
									id="province"
									:value="saleData.user_data.province"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: District -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="DISTRITO"
								label-for="district"
							>
								<b-form-input
									id="district"
									:value="saleData.user_data.district"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Postal Code -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="CÓDIGO POSTAL"
								label-for="postcode"
							>
								<b-form-input
									id="postcode"
									:value="saleData.user_data.postcode"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Cellphone -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="TELÉFONO CELULAR"
								label-for="phone"
							>
								<b-form-input
									id="phone"
									:value="saleData.user_data.phone"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Documento (DNI o Carnet de Extranjería) -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								:label="saleData.user_data.document_type === 'CE' ? 'CARNET DE EXTRANJERÍA' : 'DNI'"
								label-for="dni"
							>
								<b-form-input
									id="dni"
									:value="saleData.user_data.dni"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Email -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="CORREO ELECTRÓNICO"
								label-for="email"
							>
								<b-form-input
									id="email"
									:value="saleData.user_data.email"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Payment Method -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="MÉTODO DE PAGO"
								label-for="payment_method"
							>
								<b-form-input
									id="payment_method"
									:value="saleData.payment_method ? saleData.payment_method.name : '---'"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Delivery Type -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="TIPO DE ENTREGA"
								label-for="delivery_type"
							>
								<b-form-input
									id="delivery_type"
									:value="saleData.delivery_type ? saleData.delivery_type.name : '---'"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- Sale: Fulfillment Warehouse -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="ALMACÉN DE DESPACHO"
								label-for="fulfillment_warehouse"
							>
								<b-form-input
									id="fulfillment_warehouse"
									:value="warehouseLabel"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- Descuento aplicado: cupón, código de referido o Botipuntos -->
						<b-col
							md="6"
							xl="4"
						>
							<b-form-group
								label="DESCUENTO APLICADO"
								label-for="discount_applied"
								:description="discountApplied.detail"
							>
								<b-form-input
									id="discount_applied"
									:value="discountApplied.value"
									readonly
								/>
							</b-form-group>
						</b-col>

						<b-col
							v-if="saleData.has_order"
							md="6"
							xl="4"
						>
							<b-form-group
								label="NRO ORDEN"
								label-for="order_number"
							>
								<b-form-input
									id="order_number"
									:value="saleData.order_number ? saleData.order_number : '---'"
									readonly
								/>
							</b-form-group>
						</b-col>

						<b-col
							v-if="saleData.has_order"
							md="6"
							xl="4"
						>
							<b-form-group
								label="ESTADO DE ORDEN"
								label-for="order_status"
							>
								<b-form-input
									id="order_status"
									:value="saleData.order_status ? saleData.order_status : '---'"
									readonly
								/>
							</b-form-group>
						</b-col>

						<!-- User Data: Reference -->
						<b-col md="12">
							<b-form-group
								class="mb-0"
								label="INFORMACIÓN ADICIONAL"
								label-for="additional_information"
							>
								<b-form-textarea
									id="additional_information"
									rows="4"
									:value="saleData.user_data.additional_information"
									readonly
								/>
							</b-form-group>
						</b-col>
					</b-row>
				</b-card-body>
			</b-card>

			<hr />

			<!-- mb-1 + 1rem de cada columna = el mismo espacio que antes (mb-2). -->
			<b-row class="mb-1 statistic-cards">
				<b-col
					xl="2"
					md="4"
					sm="6"
				>
					<statistic-card-vertical
						hide-chart
						color="info"
						icon="StarIcon"
						:statistic="`S/ ${parseFloat(saleData.amount.$numberDecimal).toFixed(2)}`"
						statistic-title="MONTO"
					/>
				</b-col>

				<b-col
					xl="2"
					md="4"
					sm="6"
				>
					<statistic-card-vertical
						hide-chart
						color="warning"
						icon="HeartIcon"
						:statistic="`S/ ${parseFloat(saleData.subTotal.$numberDecimal).toFixed(2)}`"
						statistic-title="SUB-TOTAL"
					/>
				</b-col>

				<b-col
					xl="2"
					md="4"
					sm="6"
				>
					<statistic-card-vertical
						hide-chart
						color="danger"
						icon="AnchorIcon"
						:statistic="`S/ ${parseFloat(saleData.igv.$numberDecimal).toFixed(2)}`"
						statistic-title="IGV"
					/>
				</b-col>

				<b-col
					xl="2"
					md="4"
					sm="6"
				>
					<statistic-card-vertical
						hide-chart
						color="primary"
						icon="TruckIcon"
						:statistic="`${ saleData.delivery ? 'S/'+parseFloat(saleData.delivery.$numberDecimal).toFixed(2) : '0.00' }`"
						statistic-title="SERVICIO DE ENTREGA"
					/>
				</b-col>

				<b-col
					xl="2"
					md="4"
					sm="6"
				>
					<statistic-card-vertical
						hide-chart
						color="danger"
						icon="TagIcon"
						:statistic="`${ saleData.discount ? 'S/'+parseFloat(saleData.discount.$numberDecimal).toFixed(2) : '0.00' }`"
						statistic-title="DESCUENTO"
					/>
				</b-col>

				<b-col
					xl="2"
					md="4"
					sm="6"
				>
					<statistic-card-vertical
						hide-chart
						color="success"
						icon="DollarSignIcon"
						:statistic="`S/ ${parseFloat(saleData.totalAmount.$numberDecimal).toFixed(2)}`"
						statistic-title="MONTO TOTAL"
					/>
				</b-col>
			</b-row>

			<b-card no-body>
				<b-card-body>
					<div class="d-flex justify-content-end flex-wrap">
						<b-col
							cols="5"
							class="px-0"
						>
							<!-- filter -->
							<b-form-group class="mb-0">
								<b-input-group size="sm">
									<b-form-input
										id="filterInput"
										v-model="filter"
										type="search"
										placeholder="Buscar producto"
									/>
									<b-input-group-append>
										<b-button
											:disabled="!filter"
											@click="filter = ''"
										>Limpiar</b-button>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-col>
					</div>
				</b-card-body>

				<b-table
					striped
					hover
					responsive
					class="position-relative"
					:per-page="perPage"
					:current-page="currentPage"
					:items="items"
					:fields="fields"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					:sort-direction="sortDirection"
					:filter="filter"
					:filter-included-fields="filterOn"
					@filtered="onFiltered"
				>
					<template #cell(id)="data">{{ data.index + 1 }}</template>

					<template #cell(price)="data">{{ `S/. ${(data.item.price).toFixed(2)}` }}</template>
				</b-table>

				<b-card-body class="d-flex justify-content-end flex-wrap pt-0">
					<!-- pagination -->
					<div>
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							first-number
							last-number
							prev-class="prev-item"
							next-class="next-item"
							class="mb-0"
						>
							<template #prev-text>
								<feather-icon
									icon="ChevronLeftIcon"
									size="18"
								/>
							</template>
							<template #next-text>
								<feather-icon
									icon="ChevronRightIcon"
									size="18"
								/>
							</template>
						</b-pagination>
					</div>
				</b-card-body>
			</b-card>
		</b-col>
	</div>
</template>

<script>
import {
	BButtonGroup,
	BButton,
	BRow,
	BCol,
	BFormGroup,
	BFormInput,
	BForm,
	BFormCheckbox,
	BCard,
	BFormTextarea,
	BCardText
} from "bootstrap-vue"
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue"
import moment from "moment"

export default {
	components: {
		StatisticCardVertical,
		BCard,
		BFormTextarea,
		BButtonGroup,
		BButton,
		BRow,
		BCol,
		BCardText,
		BFormGroup,
		BFormInput,
		BFormCheckbox,
		BForm
	},
	props: {
		saleData: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			perPage: 100,
			totalRows: 1,
			currentPage: 1,
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: ["name"],
			fields: [
				{ key: "id", label: "#", sortable: false },
				{ key: "name", label: "NOMBRE DEL PRODUCTO", sortable: true },
				{ key: "sku", label: "SKU", sortable: false },
				{ key: "qty", label: "CANTIDAD", sortable: true },
				{ key: "price", label: "PRECIO (S/)", sortable: true }
			],
			items: []
		}
	},
	computed: {
		/* Snapshot del almacén guardado en la venta. Las ventas anteriores al
		   multi-almacén no lo tienen. */
		warehouseLabel() {
			const warehouse = this.saleData.warehouse_data

			return warehouse && warehouse.alias ? warehouse.alias : '---'
		},
		/*  Qué descuento se aplicó y de dónde vino. `discount_data` lo escribe
		    la web al crear la venta; para las anteriores el backend lo
		    reconstruye (`inferred`) y aquí se avisa.  */
		discountApplied() {
			const data = this.saleData.discount_data

			if (!data || !data.type) return { value: 'Sin descuento', detail: null }

			const monto = Number(data.amount) > 0 ? `S/ ${Number(data.amount).toFixed(2)}` : null
			const envio = data.free_delivery ? 'envío gratis' : null
			const partes = [monto, envio].filter(Boolean).join(' · ')
			const nota = data.inferred ? ' (reconstruido: la venta es anterior al registro del tipo de descuento)' : ''

			switch (data.type) {
				case 'CUPON':
					return { value: `Cupón ${data.code || '---'}`, detail: partes + nota }
				case 'REFERIDO':
					return {
						value: `Código de referido ${data.code || '---'}`,
						detail: [data.referrer ? `Dueño del código: ${data.referrer}` : null, partes].filter(Boolean).join(' · ') + nota
					}
				case 'BOTIPUNTOS':
					return { value: `Botipuntos: ${data.points || 0} pts canjeados`, detail: partes + nota }
				default:
					return { value: '---', detail: null }
			}
		},
		sortOptions() {
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => ({ text: f.label, value: f.key }))
		}
	},
	mounted() {
		this.items = this.saleData.products
		this.totalRows = this.items.length
	},
	methods: {
		formatDate(date, format) {
			return moment(date).format(format)
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		}
	}
}
</script>

<style scoped>
.card {
	border-radius: 5px;
	box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.5) !important;
	border: 1px solid #9f5735;
	margin-bottom: 0;
}

.statistic-cards .card {
	border: 1px solid #36694b;
	/* La fila ya estira las columnas; la tarjeta debe ocuparlas por completo
	   para que "SERVICIO DE ENTREGA" (dos líneas) no deje a las demás más
	   bajas. */
	height: 100%;
	margin-bottom: 0;
}

/* Separación entre filas cuando las tarjetas envuelven (pantallas chicas). */
.statistic-cards > [class*='col'] {
	margin-bottom: 1rem;
}

.statistic-cards ::v-deep .card-body {
	display: flex;
	flex-direction: column;
	/* Anclado arriba: icono y monto quedan a la misma altura en todas las
	   tarjetas; solo el título (una o dos líneas) varía por debajo. */
	justify-content: flex-start;
	/* En columna, sin esto el avatar (ancho fijo) se pega a la izquierda. */
	align-items: center;
}

.statistic-cards ::v-deep .card-body .truncate {
	width: 100%;
}

.card-header {
	background-color: #9f5735;
	color: #fff;
	font-weight: bold;
}

.card-body {
	padding-top: 1.5rem !important;
}

.card-body input,
.card-body textarea {
	font-weight: bold;
}
</style>